// @flow
import DetailsMultiple from './DetailsMultiple';

export default DetailsMultiple;
